import axios from  'axios';
import S3 from 'react-aws-s3';

const config = require('../../config').get(process.env.REACT_APP_ENVIRONMENT);

export function getExercises() {
  return axios.get(`${config.URL}/api/workout/exerciseMapping/`)
    .then(res => res.data)
    .catch(err => err)
}

export function createWorkout(exercise, workoutName, trainerName) {
  return axios.post(`${config.URL}/api/workout/design/`, {exercise, workoutName, trainerName})
  .then(res => res.data)
  .catch(err => err)
}

export function uploadVideo(exerciseName, trainerName, fileName, file) {
  const bucket = `exercisesvideos/${exerciseName}/${trainerName}`;

  const s3Params = { 
    accessKeyId: 'AKIAX3MJ5BSSBPCED4VY',
    secretAccessKey: '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',
    region: 'eu-central-1',
    bucketName: bucket
  }
  
  const s3 = new S3(s3Params)

  return s3.uploadFile(file, file)
}


